module.exports = __webpack_public_path__ + "06742cf8653c09b0f90a64624c5a69ce.svg";